/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectItemsQuery } from '../../models/get-project-items-query';
import { GetProjectItemsQueryResult } from '../../models/get-project-items-query-result';

export interface ApiProjectItemGetProjectItemsPost$Params {
      body?: GetProjectItemsQuery
}

export function apiProjectItemGetProjectItemsPost(http: HttpClient, rootUrl: string, params?: ApiProjectItemGetProjectItemsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemGetProjectItemsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectItemsQueryResult>;
    })
  );
}

apiProjectItemGetProjectItemsPost.PATH = '/api/ProjectItem/GetProjectItems';
